"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("./Link"));
var _Wantedly = _interopRequireDefault(require("./Wantedly"));
var _fa = require("react-icons/fa6");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

class SocialLink extends _react.default.Component {
  buildSocialIcon(label) {
    switch (label) {
      case 'facebook':
        return {
          color: '#0078c9',
          icon: /*#__PURE__*/_react.default.createElement(_fa.FaFacebookF, null)
        };
      case 'twitter':
        return {
          color: '#00a9f2',
          icon: /*#__PURE__*/_react.default.createElement(_fa.FaXTwitter, null)
        };
      case 'linkedin':
        return {
          color: '#004a7d',
          icon: /*#__PURE__*/_react.default.createElement(_fa.FaLinkedinIn, null)
        };
      case 'googleplus':
        return {
          color: '#d25533',
          icon: /*#__PURE__*/_react.default.createElement(_fa.FaGooglePlusG, null)
        };
      case 'youtube':
        return {
          color: '#cc181e',
          icon: /*#__PURE__*/_react.default.createElement(_fa.FaYoutube, null)
        };
      case 'xing':
        return {
          color: '#00a9f2',
          icon: /*#__PURE__*/_react.default.createElement(_fa.FaXing, null)
        };
      case 'wantedly':
        return {
          color: '#00a4bb',
          icon: /*#__PURE__*/_react.default.createElement(_Wantedly.default, null)
        };
      case 'wechat':
        return {
          color: '#00a4bb',
          icon: /*#__PURE__*/_react.default.createElement(_fa.FaWeixin, null)
        };
    }
    return false;
  }
  render() {
    const linkStyles = {
      display: 'flex',
      height: '41px',
      width: '41px',
      margin: '7px',
      fontSize: '18px',
      backgroundColor: '#262626',
      borderRadius: '100%',
      color: '#a8a8a8',
      transition: 'all 0.2s ease-in-out',
      alignItems: 'center',
      justifyContent: 'center'
    };
    const network = this.buildSocialIcon(this.props.network);

    // If the network is not found, return empty div
    if (!network) {
      return /*#__PURE__*/_react.default.createElement("div", null);
    }

    // Override styles if there is overrides
    if (this.props.styleOverrides) {
      Object.assign(linkStyles, this.props.styleOverrides);
    }
    return /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: this.props.href,
      className: 'text-center social-link ' + this.props.network,
      target: "_blank",
      style: linkStyles,
      hoverStyles: {
        color: '#fff',
        backgroundColor: network.color
      }
    }, network.icon);
  }
}
exports.default = SocialLink;
SocialLink.propTypes = {
  network: _propTypes.default.string,
  href: _propTypes.default.string,
  styleOverrides: _propTypes.default.object
};